/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UserCircleStatusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACNElEQVR4nMVVO2sUURReUHzgGztBUbEVrXxUWwUGZs5jhbvnzBhdLHxgZW8RRQIW+ivSpjCgSAoTexEj2Anqam80MUExopzddXd29s5jUciF08yce75zvu+799Zqm7mcc/siim8i6SMk+QCkP5B1DVnbwDJHFF8Pw+TA2IXrrdYOZJ0C0lVk/V0UlgMkd2xPpeJR5I4g6VJZYcwG6VJ4ITleWJxIDgPJp9EC8hlZryLqIQtguQYsyyPTsH4EcMe8xYMg2I4srz3d/UTUs9l8aDTPAenGKIi88tJlPPo5lsd5EwPLkxxd7maoae1Hlq9+fuVBLgDpQy8A68qQu5D1Rr5LZOwJLMzCAwDzeb4NN3waRByf92mQ0mIuPcG7Qq+zLJtz/rrIuvO5KBPtNMD3sX3PpQdwPS3Weg7/v5DkKZEkRHLUObelXq9vNa8jNi8jyYw5hig57ZzbPTExuStsNE/ZNySdL6FI3jDHZ2r/Y5kgGZstIOKeinsJSZ4jyzcLYF0kimEoqXMNDADeBsHFvVWKI+v9Ah2mhw4akH7p/MDmlcqdc4nQLFG6m6kePe+ZLx0kSk4iaiO3+w4tZQC60N/gnNtmF1UP+YWJPNRBdoIqbwXryuhbwNpOJUz+C4DdbyMbze9I+rKfRDoPrC0Ad8I5t3OggS6WApA8K3gy5baN6Dmht7qNxFAK0NAwj4HOMrt2LSyzvcO4Zie7LzTrdP5VIfcKi1ddZgRzS/fx11WjJd35Hx2SatCz8+u9AAAAAElFTkSuQmCC)
 */
export const UserCircleStatusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M23 12.38c-.02.38-.45.58-.78.4a6.97 6.97 0 0 0-6.27-.08.54.54 0 0 1-.44 0 8.97 8.97 0 0 0-11.16 3.55c-.1.15-.1.35 0 .5.37.58.8 1.13 1.28 1.61.24.24.64.15.8-.15.19-.38.39-.73.58-1.02.14-.21.43-.1.4.15l-.19 1.96c-.02.19.07.37.23.47A8.96 8.96 0 0 0 12 21a.4.4 0 0 1 .38.27c.1.33.25.65.4.95.18.34-.02.76-.4.77L12 23a11 11 0 1 1 11-10.62ZM15.5 7.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M24 19a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
        className={colorClass}
      />
    </svg>
  );
};
